import { useCodatAuth } from "@codat/client-cookie-manager";
import makeApi from "api/makeApi";
import { AxiosInstance } from "axios";
import React, { PropsWithChildren, createContext, useContext } from "react";

export const ProxyApiContext = createContext<AxiosInstance | undefined>(
  undefined
);

export const useProxyApi = (): AxiosInstance => {
  const apiInstance = useContext(ProxyApiContext);

  if (apiInstance === undefined) {
    throw new Error("Proxy api instance must be initialised before use");
  }
  return apiInstance;
};

export const ProxyApiProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const auth = useCodatAuth();
  const proxyApi = makeApi(auth);

  return (
    <ProxyApiContext.Provider value={proxyApi}>
      {children}
    </ProxyApiContext.Provider>
  );
};
